import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth';

const TARGET = '/change-password';

// While `must_reset_password=true` (after an admin issued a temp password),
// every protected/authed route bounces the user to /change-password until
// they pick a new one. The change-password endpoint clears the flag and
// refreshAuth lets them through on the next render.
export function useForcePasswordChange(): void {
  const mustReset = useAuthStore((s) => s.user?.must_reset_password);
  const nav = useNavigate();
  const location = useLocation();
  useEffect(() => {
    if (!mustReset) return;
    if (location.pathname === TARGET) return;
    nav(TARGET, { replace: true });
  }, [mustReset, location.pathname, nav]);
}
